angular.module('cfn').directive('cfnBookingSoilsample', [
  '$rootScope',
  'i18nFilter',
  'bookingRules',
  function($rootScope, i18nFilter, bookingRules) {
    return {
      restrict: 'E',
      templateUrl: require('./soilSampleTable.html'),
      controller: [
        '$scope',
        function($scope) {
          // Load data from common booking state object into local format
          bookingRules.elements.soilSample.onLoad = function(result) {
            $scope.details.specialData = result.extraData || {};
            $scope.loadData();
          };

          // Transform details-data (fieldList, seedList, ...) to BE-Data (assets, products,...)
          bookingRules.elements.soilSample.onSave = function(result) {
            result.extraData = _.extend(
              $scope.details.specialData,
              result.extraData
            );
          };

          bookingRules.elements.soilSample.onInsert = function(soilSample) {};

          // Solange die Typen nicht definiert sind, überschreiben wir das hier, der reguläre Weg ist
          // einfach über die I18N Tabelle, wenn es bei einem Enum bleibt
          enums['SoilSampleSoilTypeEnum']['EMPTY'] =
            enums.SoilTypeEnum['EMPTY'];
          enums['SoilSampleSoilTypeEnum']['TYPE_1'] =
            enums.SoilTypeEnum['SAND'];
          enums['SoilSampleSoilTypeEnum']['TYPE_2'] =
            enums.SoilTypeEnum['LOAMY_SAND'] +
            ', ' +
            enums.SoilTypeEnum['SANDY_SILT'];
          enums['SoilSampleSoilTypeEnum']['TYPE_3'] =
            enums.SoilTypeEnum['STRONG_SANDY_LOAM'] +
            ', ' +
            enums.SoilTypeEnum['LOAMY_SILT'];
          enums['SoilSampleSoilTypeEnum']['TYPE_4'] =
            enums.SoilTypeEnum['SANDY_LOAM'] +
            ', ' +
            enums.SoilTypeEnum['SILTY_LOAM'] +
            ', ' +
            enums.SoilTypeEnum['LOAM'];
          enums['SoilSampleSoilTypeEnum']['TYPE_5'] =
            enums.SoilTypeEnum['SILTY_CLAYEY_LOAM'] +
            ', ' +
            enums.SoilTypeEnum['CLAYEY_LOAM'] +
            ', ' +
            enums.SoilTypeEnum['CLAY'];

          var sampleObj = {
            fieldId: null,
            plannedDat: null,
            designator: null,
            soilType: null,
            careLevelpHVal: null,
            valuepHVal: null,
            careLevelP2O5: null,
            valueP2O5: null,
            careLevelK2O: null,
            valueK2O: null,
            careLevelMgO: null,
            valueMgO: null
          };

          /**
           * init data
           */
          $scope.loadData = function() {
            //TODO: this overriged the GENERAL behaviour of controller.loadData. meanging that everywhere soil samples will be added. Additionally the code overwrote all existing other data NEVER do something like this.(ASG)

            if (!$scope.details.specialData) {
              $scope.details.specialData = {};
            }
            if (!$scope.details.specialData.soilSampleData) {
              $scope.details.specialData.soilSampleData = {};
            }
            if (!$scope.details.specialData.soilSampleData.soilSamples) {
              $scope.details.specialData.soilSampleData.soilSamples = [];
            }

            $scope.details.specialData.soilSampleList = {};
            $scope.details.specialData.soilSampleAVERAGEList = {};

            $.each(
              $scope.details.specialData.soilSampleData.soilSamples,
              function(k, v) {
                if (!v.fieldId) return;

                if (!$scope.details.specialData.soilSampleList[v.fieldId]) {
                  $scope.details.specialData.soilSampleList[v.fieldId] = [];
                }
                if (v.designator != 'AVERAGE') {
                  // v.soilType=enums.SoilTypeEnumNoGen.options[v.soilType];
                  $scope.details.specialData.soilSampleList[v.fieldId].push(v);
                }
              }
            );

            $.each(
              $scope.details.specialData.soilSampleData.soilSamples,
              function(k, v) {
                if (!v.fieldId) return;
                if (v.designator == 'AVERAGE') {
                  $scope.details.specialData.soilSampleAVERAGEList[
                    v.fieldId
                  ] = v;
                }
              }
            );
          };

          /**
           * update lists after changes
           */
          $scope.updateSamplesForExtraData = function() {
            $scope.details.specialData.soilSampleData.soilSamples = [];

            $.each($scope.details.specialData.soilSampleList, function(
              fieldId,
              samples
            ) {
              samples.forEach(function(v) {
                $scope.details.specialData.soilSampleData.soilSamples.push(v);
              });
            });
            $.each($scope.details.specialData.soilSampleAVERAGEList, function(
              fieldId,
              averageList
            ) {
              $scope.details.specialData.soilSampleData.soilSamples.push(
                averageList
              );
            });
          };

          /**
           * add a new empty soil sample row with field id set
           */
          $scope.addNewItem = function(fieldId) {
            $scope.loadData();
            if (!fieldId) return;

            if (!$scope.details.specialData.soilSampleList[fieldId]) {
              $scope.details.specialData.soilSampleList[fieldId] = [];
            }

            var obj = $.extend(false, {}, sampleObj);
            obj.fieldId = fieldId;
            $scope.details.specialData.soilSampleList[fieldId].push(obj);

            if ($scope.details.specialData.soilSampleList[fieldId].length > 1) {
              var obj = $.extend(false, {}, sampleObj);
              obj.fieldId = fieldId;
              obj.designator = 'AVERAGE';
              $scope.details.specialData.soilSampleAVERAGEList[fieldId] = obj;
            }

            $scope.calculateAverage();
            $scope.updateSamplesForExtraData();
          };

          /**
           * remove a sample from list
           */
          $scope.removeFromList = function(item, fieldId) {
            var itemIndex = $scope.details.specialData.soilSampleList[
              fieldId
            ].indexOf(item);
            $scope.details.specialData.soilSampleList[fieldId].splice(
              itemIndex,
              1
            );
            $scope.updateSamplesForExtraData();
          };

          $scope.calculateAverage = function() {
            var list = {};
            $.each($scope.details.specialData.soilSampleList, function(
              fieldId,
              samples
            ) {
              samples.forEach(function(sample) {
                if (list[fieldId]) {
                  list[fieldId].factor++;
                  // Don't calculate an average if at least one value is missing
                  list[fieldId].valueP2O5 =
                    sample.valueP2O5 !== null
                      ? list[fieldId].valueP2O5 + sample.valueP2O5
                      : null;
                  list[fieldId].valueK2O =
                    sample.valueK2O !== null
                      ? list[fieldId].valueK2O + sample.valueK2O
                      : null;
                  list[fieldId].valueMgO =
                    sample.valueMgO !== null
                      ? list[fieldId].valueMgO + sample.valueMgO
                      : null;
                } else {
                  list[fieldId] = {
                    factor: 1,
                    valueP2O5: sample.valueP2O5,
                    valueK2O: sample.valueK2O,
                    valueMgO: sample.valueMgO
                  };
                }
              });
            });

            $.each($scope.details.specialData.soilSampleAVERAGEList, function(
              fieldId,
              averageList
            ) {
              if (list[fieldId]) {
                // CFNPOC-3518
                averageList.valueP2O5 = list[fieldId].valueP2O5
                  ? preciseRound(
                      list[fieldId].valueP2O5 / list[fieldId].factor,
                      2
                    )
                  : undefined;
                averageList.valueK2O = list[fieldId].valueK2O
                  ? preciseRound(
                      list[fieldId].valueK2O / list[fieldId].factor,
                      2
                    )
                  : undefined;
                averageList.valueMgO = list[fieldId].valueMgO
                  ? preciseRound(
                      list[fieldId].valueMgO / list[fieldId].factor,
                      2
                    )
                  : undefined;
              }
            });
          };

          /**
           * validate form / remove empty rows
           */
          $scope.validateRows = function(item) {
            if (
              !item.careLevelpHVal &&
              !item.valuepHVal &&
              !item.careLevelP2O5 &&
              !item.valueP2O5 &&
              !item.careLevelK2O &&
              !item.valueK2O &&
              !item.careLevelMgO &&
              !item.valueMgO
            )
              return false;

            return true;
          };

          $scope.$watch(
            'details.specialData',
            function(newVal, oldVal) {
              if (oldVal == newVal) return;
              if (!$scope.ele.active)
                // only if visible
                return;

              var clList = [];
              var clObj = {
                fieldId: null,
                careLevelpHVal: [],
                careLevelpHValCount: 0,
                careLevelP2O5: [],
                careLevelP2O5Count: 0,
                careLevelK2O: [],
                careLevelK2OCount: 0,
                careLevelMgO: [],
                careLevelMgOCount: 0
              };

              for (var i in $scope.details.specialData.soilSampleList) {
                $.each($scope.details.specialData.soilSampleList[i], function(
                  k,
                  sample
                ) {
                  if (!clList[i]) {
                    clList[i] = $.extend(false, {}, clObj);
                  }
                  clList[i].fieldId = sample.fieldId;

                  if (
                    sample.careLevelpHVal &&
                    $.inArray(
                      sample.careLevelpHVal,
                      clList[i].careLevelpHVal
                    ) == -1
                  )
                    clList[i].careLevelpHValCount += 1;
                  if (sample.careLevelpHVal)
                    clList[i].careLevelpHVal.push(sample.careLevelpHVal);
                  if (
                    sample.careLevelP2O5 &&
                    $.inArray(sample.careLevelP2O5, clList[i].careLevelP2O5) ==
                      -1
                  )
                    clList[i].careLevelP2O5Count += 1;
                  if (sample.careLevelP2O5)
                    clList[i].careLevelP2O5.push(sample.careLevelP2O5);
                  if (
                    sample.careLevelK2O &&
                    $.inArray(sample.careLevelK2O, clList[i].careLevelK2O) == -1
                  )
                    clList[i].careLevelK2OCount += 1;
                  if (sample.careLevelK2O)
                    clList[i].careLevelK2O.push(sample.careLevelK2O);
                  if (
                    sample.careLevelMgO &&
                    $.inArray(sample.careLevelMgO, clList[i].careLevelMgO) == -1
                  )
                    clList[i].careLevelMgOCount += 1;
                  if (sample.careLevelMgO)
                    clList[i].careLevelMgO.push(sample.careLevelMgO);
                });
              }
              $scope.calculateAverage();
              //wenn mehr als 2 unterschiedliche Versorgungsstufen vorhanden sind Meldung ausgeben
              for (var i in clList) {
                if (
                  clList[i].careLevelpHValCount > 2 ||
                  clList[i].careLevelP2O5Count > 2 ||
                  clList[i].careLevelK2OCount > 2 ||
                  clList[i].careLevelMgOCount > 2
                ) {
                  $.each($scope.details.fieldList, function(k, v) {
                    if (clList[i].fieldId == v.asset.id) {
                      $rootScope.alertController.addTemporaryAlert(
                        i18nFilter(
                          'fe.booking.soilsample.noFieldAverageResult',
                          'Der Mittelwert für die Versorgungsstufe kann nicht ermittelt werden.'
                        ),
                        'warn'
                      );
                      return;
                    }
                  });
                }
              }
              $scope.updateSamplesForExtraData();
            },
            true
          );

          $scope.$watch('details.fieldList.length', function(newVal, oldVal) {
            if (oldVal == newVal) return;

            if ($scope.ele.active) {
              // only if visible
              $.each($scope.details.fieldList, function(k, v) {
                if (
                  $scope.details &&
                  $scope.details.specialData &&
                  !$scope.details.specialData.soilSampleList[v.asset.id]
                )
                  $scope.addNewItem(v.asset.id);
              });

              $scope.updateSamplesForExtraData();
            }
          });
        }
      ]
    };
  }
]);
